import React from 'react';
import { Section } from '../components/sections';
import { Layout } from '../components/layout';
import {Flyin} from '../components/sections/flyin';

interface PageProps {
  pageContext: {
    title: string;
    metaTitle?: string;
    slug: string;
    description: string;
    sections: any[];
  };
}

const PageTemplate = ({ pageContext }: PageProps) => {
  const { title, metaTitle, description, sections } = pageContext;

  return (
    <Layout  title={metaTitle ? metaTitle : title} description={description}>
      <div>
        {sections && sections.map((section, sectionIndex) => {

          return (
            <Section key={sectionIndex} sectionData={section.sectionData} sectionType={section.contentType} />
          );
        })}
      </div>
      {!pageContext.title.includes('Newsletter')  && <Flyin heading="Newsletter" />}
    </Layout>
  );
};

export default PageTemplate;
